exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-29878914] .el-form-item__label {\n  text-align: left;\n}\n.custom_button[data-v-29878914] {\n  display: flex;\n  justify-content: right;\n  margin-right: 10px;\n  margin-top: 10px;\n}\n.custom_button_error[data-v-29878914] {\n  display: flex;\n  justify-content: right;\n  margin-top: 20px;\n}\n.input-common[data-v-29878914] {\n  margin-right: 5px;\n}\n", ""]);

// exports
